import { CUSTOMER_ROLES } from "../../auth/model";

import { AppState } from "./model";
import { customerUserSelector } from "./selectors";
import { detailRoutes } from "./detailRoutes";

const detailRoute = () => ({
    "/:customerUserId": {
        title: (state: AppState) => customerUserSelector(state).firstName || "Customer User",
        "/edit": {
            title: "Edit"
        },
        ...detailRoutes
    }
});

export const routes = {
    "/customerUsers": {
        title: "CustomerUsers",
        authorise: [CUSTOMER_ROLES.customerAdministrator],
        ...detailRoute(),
        "/create": {
            title: "Create CustomerUser"
        }
    }
};
